export const Device = {
  isAndroid: navigator.userAgent.toLowerCase().indexOf("android") > -1,
  isIos: navigator.userAgent.toLowerCase().indexOf("iphone") > -1,
  isDesktop:
    navigator.userAgent.toLowerCase().indexOf("iphone") === -1 &&
    navigator.userAgent.toLowerCase().indexOf("android") === -1,
};

// Central message listener — set up once, route messages to the correct pending promise
type PendingPromise = {
  resolve: (value: any) => void;
  reject: (reason: any) => void;
};
const pendingPromises = new Map<string, PendingPromise>();
let centralListenerInitialized = false;

function initCentralListener(): void {
  if (centralListenerInitialized) return;
  centralListenerInitialized = true;

  const target = Device.isAndroid ? document : window;
  target.addEventListener("message", ({ data: payload }: any) => {
    const { type, params } =
      typeof payload === "object" ? payload : JSON.parse(payload);
    const pending = pendingPromises.get(type);
    if (pending) {
      pendingPromises.delete(type);
      pending.resolve(params);
    }
    // Messages that don't match any pending promise are safely ignored
  });
}

interface ReactNativeWindow extends Window {
  ReactNativeWebView?: {
    postMessage: (body: string) => void;
  };
}
declare const window: ReactNativeWindow;
interface IPostMessagePayload {
  type: string;
  [key: string]: unknown;
}
export const postMessage = async (body: IPostMessagePayload): Promise<any> => {
  window.ReactNativeWebView?.postMessage(JSON.stringify(body));

  if (body.type !== "NAVIGATE_BACK") {
    console.log("send postMessage " + JSON.stringify(body));
  }

  return new Promise((resolve, reject) => {
    initCentralListener();
    pendingPromises.set(body.type, { resolve, reject });
  });
};
